"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TableSettingsDialogFooter = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var TableSettingsDialogFooter = function TableSettingsDialogFooter(props) {
  var hasChanged = props.hasChanged,
      isResetAll = props.isResetAll,
      immediateChange = props.immediateChange,
      resetButtonText = props.resetButtonText,
      onHide = props.onHide,
      closeButtonText = props.closeButtonText,
      cancelButtonText = props.cancelButtonText,
      applyButtonText = props.applyButtonText,
      onResetColumnChanges = props.onResetColumnChanges,
      onConfirmResetColumnChanges = props.onConfirmResetColumnChanges,
      onCancelResetColumnChanges = props.onCancelResetColumnChanges,
      onDiscardChanges = props.onDiscardChanges,
      onApplyChanges = props.onApplyChanges;
  var restButtonClassNames = (0, _classnames.default)('btn', 'btn-link', !hasChanged && 'disabled');
  return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: 'pull-left'
  }, !isResetAll && /*#__PURE__*/_react.default.createElement("div", {
    className: restButtonClassNames,
    onClick: onResetColumnChanges
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'rioglyph rioglyph-revert text-size-small margin-right-10'
  }), resetButtonText), isResetAll && /*#__PURE__*/_react.default.createElement("div", {
    className: 'btn-group'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'btn btn-icon-only btn-default margin-right-5 btn-outline',
    onClick: onCancelResetColumnChanges
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'rioglyph rioglyph-remove'
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: 'btn btn-primary btn-icon-only',
    onClick: onConfirmResetColumnChanges
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: 'rioglyph rioglyph-ok'
  })))), immediateChange ? /*#__PURE__*/_react.default.createElement("div", {
    className: 'pull-right'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'btn btn-default',
    onClick: onHide
  }, closeButtonText)) : /*#__PURE__*/_react.default.createElement("div", {
    className: 'pull-right'
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: 'btn btn-default',
    onClick: onDiscardChanges
  }, cancelButtonText), /*#__PURE__*/_react.default.createElement("div", {
    className: 'btn btn-primary',
    onClick: onApplyChanges
  }, applyButtonText)));
};

exports.TableSettingsDialogFooter = TableSettingsDialogFooter;
TableSettingsDialogFooter.defaultProps = {
  hasChanged: false,
  isResetAll: false,
  immediateChange: false,
  resetButtonText: '',
  closeButtonText: '',
  cancelButtonText: '',
  applyButtonText: '',
  onHide: function onHide() {
    return undefined;
  },
  onResetColumnChanges: function onResetColumnChanges() {
    return undefined;
  },
  onDiscardChanges: function onDiscardChanges() {
    return undefined;
  },
  onApplyChanges: function onApplyChanges() {
    return undefined;
  }
};
TableSettingsDialogFooter.propTypes = {
  hasChanged: _propTypes.default.bool,
  isResetAll: _propTypes.default.bool,
  immediateChange: _propTypes.default.bool,
  resetButtonText: _propTypes.default.node,
  closeButtonText: _propTypes.default.node,
  cancelButtonText: _propTypes.default.node,
  applyButtonText: _propTypes.default.node,
  onHide: _propTypes.default.func,
  onResetColumnChanges: _propTypes.default.func,
  onDiscardChanges: _propTypes.default.func,
  onApplyChanges: _propTypes.default.func
};